export default __webpack_public_path__ + "static/media/Favourite.00df2772.svg";